import { __require as r } from "../bundled_deps/.pnpm/use-sync-external-store@1.6.0_react@19.2.4/bundled_deps/use-sync-external-store/shim/index.js";
var i = r();
export {
  i as s
};
